import _ from 'lodash';
import numbro from 'numbro';

function parsePriceValue(price, quantity = null) {
  return parseValue((price?.value ?? 0) * (quantity ?? 1));
}

function parseValue(value) {
  if (value == null) return '';
  return numbro(value ?? 0).format();
}

function parseText(text) {
  if (_.isEmpty(text)) return null;
  return numbro(text).value();
}

function parseMinMaxValue(
  category,
  item,
  { bypassItemPrices = false, computeMin = true } = {}
) {
  let result = 0;

  const f = computeMin ? _.min : _.max;
  if (!bypassItemPrices) {
    result = f(item?.prices?.map((p) => p.value ?? 0));
  }

  const optionGroups = item?.option_groups ?? category?.option_groups;
  optionGroups?.forEach((og) => {
    for (let i = 0; i < og.required_min ?? 0; i += 1) {
      const value = f(
        og.options?.filter((o) => !o.blocked)?.map((o) => o.price?.value ?? 0)
      );
      result += value;
    }
  });

  return result;
}

export { parsePriceValue, parseValue, parseText, parseMinMaxValue };
